import { axios, axios5 } from '../utils/axios';
import { TranslationType } from '@/stores/TranslationStore/types';

export interface ISrtTranslateParams {
  email: string;
  key: string;
  sourceLang: string;
  targetLang: string;
  srtUrl: string;
}

export interface IAITranslateParams {
  key: 'KT_LocalFile' | 'KT_YouTube';
  trans: {
    email: string;
    key: string;
    sourceLang: string;
    targetLang: string;
    srtUrl?: string;
  };
  video: {
    uid?: number;
    url: string;
    title?: string;
    intro?: string;
    duration: number;
  };
}

export interface ITranslationListParams {
  limit: number;
  offset: number;
  status?: string;
  type?: string;
  start?: string;
  end?: string;
}

export interface ITranslationListResponse {
  count: number;
  list: TranslationType[];
}

const translationServices = {
  srtTranslate: (params: any) => axios5.post('/ai/translate-srt-for-studio', params),

  aiTranslate: (params: IAITranslateParams) => axios.post('/order/v1/trans/ai', params),

  getTranslationList: (params: ITranslationListParams) =>
    axios.get<ITranslationListResponse, ITranslationListResponse>('/order/v1/trans/list', {
      params,
    }),
};

export default translationServices;
